module.exports = __webpack_public_path__ + "static/media/screenshot(14).13b37e9b.jpg";